import { AuthProvider, useAuth, UserManager } from 'oidc-react';
import type React from 'react';
import type { ComponentType } from 'react';
import { FullScreenLoadingComponent } from '../components/misc';
import config from '../config';

export const userManager = new UserManager({
  automaticSilentRenew: true,
  authority: config.authServer,
  client_id: 'fsl_memberportal_frontend',
  redirect_uri: `${window.location.protocol}//${window.location.host}/callback`,
  response_type: 'code',
  scope: 'openid profile fsl_memberportal_backend fsl_employments fsl_positions_of_trust fsl_districts fsl_internal_client',
  post_logout_redirect_uri: config.postLogoutUrl ?? `${window.location.protocol}//${window.location.host}`,
});

export const withOidc = (App: ComponentType<any>) => {
  function LoaderOrApp() {
    const auth = useAuth();

    if (auth?.userData) {
      return <App />;
    }

    return <FullScreenLoadingComponent />;
  }

  return () => {
    return (
      <AuthProvider
        userManager={userManager}
        onBeforeSignIn={() => {
          sessionStorage.setItem('OnSigninRedirect', document.location.pathname + document.location.search + document.location.hash);
        }}
        onSignIn={(userData) => {
          console.log('AuthProvider onSignIn fired', userData);
          // The navigation will be handled by FslCallbackPage
        }}
      >
        <LoaderOrApp />
      </AuthProvider>
    );
  };
};
